export default "__VITE_ASSET__AtGw0DHo__"